import { AccountMachines } from './domain/Account/Machines';
import { UtilsMachines } from './domain/Utils/Machines';

export default {
  AccountMachines,
  UtilsMachines,
};
